import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ticked_line.svg'


const _withScopeId = n => (_pushScopeId("data-v-b015e0fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row statistics__exports" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Exporter", -1))
const _hoisted_3 = { class: "row statistics__exports" }
const _hoisted_4 = {
  class: "cards-container",
  id: "statistics__cards"
}
const _hoisted_5 = { class: "rate" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rate__title" }, "Taux de réussite", -1))
const _hoisted_7 = {
  key: 0,
  class: "rate__value"
}
const _hoisted_8 = {
  key: 0,
  class: "card"
}
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "statistics-ticked-line" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "25%", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "50%", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "75%", -1))
const _hoisted_15 = { class: "unit" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "",
  style: {"height":"100%"}
}
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Téléchargement terminé ")

import { Sheet } from "@/domains/cruds/sheets/sheets";
import { reactive } from "@vue/reactivity";
import { sheetStatisticsColumns } from "../config";
import { downloadXLSX as downloadXLSXFile, generatePDF } from "../exports";
import {
    useStatistics,
    NumberStats,
    RelationStats,
    Statistics,
    IntervalStats,
    SimpleNumberStats,
} from "../statistics";
import { getIntervalLabel, getUnit } from "../tools";
import { ref } from "vue";
import Modal from "@/domains/app/components/Modal.vue";
import DetailedExport from "./DetailedExport.vue";
import { useFilters } from "../filters";
import { useUser } from "@/domains/auth/user";
import PieChart from "./PieChart.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showDetails = reactive<{ [K in keyof Sheet]?: boolean }>({
    weight: false,
});

const openDetailedDownloadModal = ref(false);

const { data: statistics } = useStatistics(true);
const { filters } = useFilters();
const { user } = useUser();

function formatNumberOrNull(
    column: string | number,
    n: undefined | null | number,
    config: { digitsAfterUnits?: number; unit?: boolean; isTotal?: boolean } = {
        digitsAfterUnits: 2,
        unit: true,
        isTotal: false,
    },
    padding = 1
): string {
    const modifier = sheetStatisticsColumns[column]?.modifier;
    n = modifier ? modifier(n, config.isTotal === true) : n;
    if (n === null || n === undefined) return "-";
    const unit =
        config.unit !== false ? getUnit(column, config.isTotal === true) : "";
    const digitsAfterUnits = config.digitsAfterUnits || 2;
    return (
        (
            "" +
            Math.round(
                n * (digitsAfterUnits > 0 ? Math.pow(10, digitsAfterUnits) : 1)
            ) /
                (digitsAfterUnits > 0 ? Math.pow(10, digitsAfterUnits) : 1)
        ).padStart(padding, "0") + (unit ? " " + unit : "")
    );
}

function parseColStatsAsSimpleNumberStats(
    stats: Statistics[number | string]
): SimpleNumberStats {
    return stats as SimpleNumberStats;
}

function parseColStatsAsNumberStats(
    stats: Statistics[number | string]
): NumberStats {
    return stats as NumberStats;
}

function parseColStatsAsRelStats(
    stats: Statistics[number | string]
): RelationStats {
    return stats as RelationStats;
}
function parseColStatsAsIntervalsStats(
    stats: Statistics[number | string]
): IntervalStats {
    return stats as IntervalStats;
}

async function downloadPDF() {
    const pdf = await generatePDF(getExportHeading());
    pdf?.save("statistiques.pdf");
}

const xlsxDownloaded = ref(false);
function downloadXLSX() {
    downloadXLSXFile(getExportHeading());
    xlsxDownloaded.value = true;
}

function getExportHeading() {
    return filters.value.find((f) => f.col === "user_id" && f.type === "=")
        ?.value == user.value?.id
        ? "" +
              user.value?.first_name +
              " " +
              user.value?.last_name +
              " " +
              user.value?.member_num
        : "";
}

function getRelationFromConfig(config: any) {
    return config?.relation;
}

return (_ctx: any,_cache: any) => {
  const _directive_loading_key = _resolveDirective("loading-key")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadXLSX()))
      }, "Excel"),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadPDF()))
      }, "PDF")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (openDetailedDownloadModal.value = true))
      }, " Détail des interventions ")
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_unref(statistics)?.success_rate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(parseColStatsAsSimpleNumberStats(_unref(statistics).success_rate).n) + "% ", 1))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statistics), (stats, column) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: column }, [
          (column != 'success_rate')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("header", _hoisted_9, _toDisplayString(_unref(sheetStatisticsColumns)[column]?.trad), 1),
                _createElementVNode("div", _hoisted_10, [
                  (_unref(sheetStatisticsColumns)[column]?.type === 'number')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(showDetails)[column] === true)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _hoisted_13,
                                _hoisted_14,
                                _createElementVNode("span", null, _toDisplayString(formatNumberOrNull(
                                        column,
                                        parseColStatsAsNumberStats(stats)?.q1,
                                        { unit: false }
                                    )), 1),
                                _createElementVNode("span", null, _toDisplayString(formatNumberOrNull(
                                        column,
                                        parseColStatsAsNumberStats(stats)?.q2,
                                        { unit: false }
                                    )), 1),
                                _createElementVNode("span", null, _toDisplayString(formatNumberOrNull(
                                        column,
                                        parseColStatsAsNumberStats(stats)?.q3,
                                        { unit: false }
                                    )), 1),
                                _createElementVNode("span", _hoisted_15, "(" + _toDisplayString(_unref(getUnit)(column, false)) + ")", 1),
                                _hoisted_16
                              ]),
                              _createElementVNode("p", null, " Ecart type: " + _toDisplayString(formatNumberOrNull(
                                        column,
                                        parseColStatsAsNumberStats(stats)?.σ
                                    )), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (
                                _unref(sheetStatisticsColumns)[column]?.showTotal ===
                                true
                            )
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Somme: " + _toDisplayString(formatNumberOrNull(
                                    column,
                                    parseColStatsAsNumberStats(stats)?.total,
                                    { isTotal: true }
                                )), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, " Moyenne: " + _toDisplayString(formatNumberOrNull(
                                    column,
                                    parseColStatsAsNumberStats(stats)?.mean
                                )), 1)
                      ], 64))
                    : (
                            _unref(sheetStatisticsColumns)[column]?.type ===
                            'number-interval'
                        )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseColStatsAsIntervalsStats(stats)?.counts, (count, intervalIndex) => {
                            return (_openBlock(), _createElementBlock("p", {
                              class: "row",
                              key: intervalIndex
                            }, _toDisplayString(_unref(getIntervalLabel)(column, count.interval)) + ": " + _toDisplayString(formatNumberOrNull(column, count.count, {
                                    digitsAfterUnits: 0,
                                    unit: false,
                                })), 1))
                          }), 128)),
                          (
                                _unref(sheetStatisticsColumns)[column]?.showTotal ===
                                true
                            )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Somme: " + _toDisplayString(formatNumberOrNull(
                                    column,
                                    parseColStatsAsNumberStats(stats)?.total,
                                    { isTotal: true }
                                )), 1))
                            : _createCommentVNode("", true),
                          (_unref(sheetStatisticsColumns)[column]?.showMean)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Moyenne: " + _toDisplayString(formatNumberOrNull(
                                    column,
                                    parseColStatsAsNumberStats(stats)?.mean
                                )), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (
                            _unref(sheetStatisticsColumns)[column]?.type === 'relation'
                        )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(PieChart, {
                              stats: parseColStatsAsRelStats(stats),
                              "traduction-key": '' + column,
                              relation: 
                                    getRelationFromConfig(
                                        _unref(sheetStatisticsColumns)[column]
                                    )
                                
                            }, null, 8, ["stats", "traduction-key", "relation"]),
                            (
                                    _unref(sheetStatisticsColumns)[column]
                                        ?.showTotal === true
                                )
                              ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Total: " + _toDisplayString(formatNumberOrNull(
                                        column,
                                        parseColStatsAsRelStats(stats)?.total,
                                        { digitsAfterUnits: 0 }
                                    )), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])), [
      [_directive_loading_key, 'statistics.stats']
    ]),
    (xlsxDownloaded.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          onCancel: ($event: any) => (null),
          onConfirm: _cache[3] || (_cache[3] = () => (xlsxDownloaded.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (openDetailedDownloadModal.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 1,
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (openDetailedDownloadModal.value = false)),
          confirm: null
        }, {
          default: _withCtx(() => [
            _createVNode(DetailedExport)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})